<template>
  <div class="captcha-wrapper">
    <vue-recaptcha
      ref="invisibleRecaptcha"
      :sitekey="recaptchaSitekey"
      recaptchaHost="www.recaptcha.net"
      @verify="onCaptchaVerify"
      @expired="onCaptchaExpire"
      size="invisible"
      :loadRecaptchaScript="true"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'CaptchaBlock',
  components: {
    VueRecaptcha,
  },
  props: {
    keyType: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapMutations({
      setIsLoadingCaptcha: 'app/IS_LOADING_CAPTCHA_UPDATED',
    }),
    execute() {
      this.setIsLoadingCaptcha(true)
      this.$refs.invisibleRecaptcha.execute()
    },
    onCaptchaVerify(recaptcha) {
      this.$emit('captcha-verify-action', { recaptcha })
      this.setIsLoadingCaptcha(false)
      this.$refs.invisibleRecaptcha.reset()
    },
    onCaptchaExpire() {
      this.$refs.invisibleRecaptcha.reset()
    },
  },
  computed: {
    ...mapState({
      isComponentLoading: state => state.app.isComponentLoading,
      isLoadingCaptcha: state => state.app.isLoadingCaptcha,
    }),
    recaptchaSitekey() {
      let keyTypeValue = ''
      switch (this.keyType) {
        case 'login':
          keyTypeValue = process.env.VUE_APP_INVISIBLE_RECAPTCHA_SITEKEY
          break
        case 'subscriptions':
          keyTypeValue = process.env.VUE_APP_INVISIBLE_SUBSCRIPTIONS_RECAPTCHA_SITEKEY
          break
      }
      return keyTypeValue
    },
  },
}
</script>

<style lang="scss">
.captcha-wrapper {
  display: none;
}
</style>
